import React from "react";
import {
  InfoCardNewAdv,
  InfoWrapper,
  PageTitle,
} from "../../../../../components";

const KpiList = () => {
  return (
    <div className="flex-1 flex flex-col gap-10 overflow-auto mt-5">
      <div className="">
        <div>
          <PageTitle title="Option1" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"} wrapperClassName="">
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            onClick={() => console.log("Clicked1")}
          />
          <InfoCardNewAdv title="KPI" value={12345} prefix="$" />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            onClick={() => console.log("Clicked3")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            onClick={() => console.log("Clicked4")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            onClick={() => console.log("Clicked5")}
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div>
          <PageTitle title="Option2" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option2"
            onClick={() => console.log("option2 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option2"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option2"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option2"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option2"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option3" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option3"
            onClick={() => console.log("option3 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option3"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option3"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option3"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option3"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div>
          <PageTitle title="Option4" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option4"
            onClick={() => console.log("option4 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option4"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option4"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option4"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option4"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option5" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option5"
            onClick={() => console.log("option5 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option5"
          />
          <InfoCardNewAdv
            title="Exit Type"
            value="Demo"
            // suffix="USD"
            layout="option5"
          />
          <InfoCardNewAdv
            title="KPI"
            value="10/11/2021"
            icon="article"
            layout="option5"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option5"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option6" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="hail"
            layout="option6"
            onClick={() => console.log("option6 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option6"
          />
          <InfoCardNewAdv title="KPI" value="Demo" layout="option6" />
          <InfoCardNewAdv
            title="Active Consultant"
            value="98"
            icon="hail"
            layout="option6"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option6"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option7" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="hail"
            layout="option7"
            onClick={() => console.log("option7 Clicked1")}
          />
          <InfoCardNewAdv
            title="Total Cost"
            value={0.0}
            prefix="$"
            suffix="USD"
            layout="option7"
          />
          <InfoCardNewAdv title="KPI" value="Demo" layout="option7" />
          <InfoCardNewAdv
            title="Active Consultant"
            value="98"
            icon="hail"
            layout="option7"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option7"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option8" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="mark_as_unread"
            layout="option8"
            onClick={() => console.log("option8 Clicked1")}
          />
          <InfoCardNewAdv
            title="Total Cost"
            value={0.0}
            prefix="$"
            layout="option8"
          />
          <InfoCardNewAdv title="KPI" value="Demo" layout="option8" />
          <InfoCardNewAdv
            title="Count of Emails"
            value="112"
            icon="mark_as_unread"
            layout="option8"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option8"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option9" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option9"
            onClick={() => console.log("option9 Clicked1")}
          />
          <InfoCardNewAdv
            title="All Invoices"
            value={2500000}
            prefix="$"
            layout="option9"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option9"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option9"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option9"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option10" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            description="Best Period"
            icon="article"
            layout="option10"
            onClick={() => console.log("option10 Clicked1")}
          />
          <InfoCardNewAdv
            title="Total Revenue"
            value={5}
            description="100% of Data"
            prefix="$"
            layout="option10"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            description="Per Period"
            layout="option10"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option10"
            description="Data Points"
          />
          <InfoCardNewAdv
            title="Total Candidates"
            value={30}
            layout="option10"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option11" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="punch_clock"
            layout="option11"
            onClick={() => console.log("option11 Clicked1")}
          />
          <InfoCardNewAdv
            title="Missing Timesheet"
            value={0}
            icon="punch_clock"
            suffix="Hrs"
            layout="option11"
          />
          <InfoCardNewAdv title="KPI" value="Demo" layout="option11" />
          <InfoCardNewAdv
            title="Count of Emails"
            value="112"
            layout="option11"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option11"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option12" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            layout="option12"
            onClick={() => console.log("option12 Clicked1")}
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            prefix="$"
            layout="option12"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option12"
          />
          <InfoCardNewAdv title="KPI" value={12345} layout="option12" />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option12"
          />
        </InfoWrapper>
      </div>
      <div className="grid grid-cols-1 gap-x-3 gap-y-2">
        <div className="">
          <PageTitle title="Option13" tag="p" className="font-bold" />
        </div>
        <InfoWrapper className={"min-w-auto"}>
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            prefix="$"
            suffix="USD"
            icon="article"
            layout="option13"
            onClick={() => console.log("option13 Clicked1")}
          />
          <InfoCardNewAdv
            title="All Invoices"
            value={2500000}
            prefix="$"
            layout="option13"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            suffix="USD"
            layout="option13"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            icon="article"
            layout="option13"
          />
          <InfoCardNewAdv
            title="KPI"
            value={12345}
            backValue={12000}
            layout="option13"
          />
        </InfoWrapper>
      </div>
    </div>
  );
};

export default KpiList;
